import { useI18n } from '../lib/i18n'
import type { TeamRef } from '../lib/types'

/**
 * The teams and squads a person is in, as small chips: main team first and marked, squads set
 * apart. With `onPick`, each chip switches the view to that team.
 */
export function TeamChips({
  teams,
  empty,
  onPick,
}: {
  teams: TeamRef[] | null | undefined
  empty?: string
  onPick?: (teamId: string) => void
}) {
  const { t } = useI18n()
  const list = teams ?? []

  if (list.length === 0) {
    return empty ? <span className="team-chips team-chips--empty tiny">{empty}</span> : null
  }

  return (
    <span className="team-chips" aria-label={t('teamPicker.memberOf')}>
      {list.map((team) => {
        const title = [
          team.kind === 'Squad' ? t('teams.kind.Squad') : t('teams.kind.Team'),
          team.isMain ? t('teams.main') : null,
        ].filter(Boolean).join(' · ')

        const className = `team-chip${team.kind === 'Squad' ? ' team-chip--squad' : ''}${team.isMain ? ' team-chip--main' : ''}`

        return onPick ? (
          <button key={team.id} type="button" className={className} title={title} onClick={() => onPick(team.id)}>
            {team.name}
          </button>
        ) : (
          <span key={team.id} className={className} title={title}>
            {team.name}
          </span>
        )
      })}
    </span>
  )
}
